const GetScriptPage = (page): JSX.Element => {
  switch (page) {
    default:
      return <></>;
  }
};

export const ScriptsPage = ({ page }): JSX.Element => {
  return GetScriptPage(page);
};
